const hardware =[
    {
        id: 1,
        title : 'کەمپیوتەرەکەت بناسە',
        img : 'image/hardware.png',
        playlist: 'https://www.youtube.com/embed?v=aaayImX3d18&list=PLmSN76VrR2ibj3Ya82zIMdOYei32wLw_l'
    }
]

export default hardware